export enum LegalEntity {
  Mfb = 1,
  Tech = 2,
  MfbAndTech = 3,
}

export enum CustomerOnboardingType {
  Investment = 1,
  Borrower = 2,
  DigitalBank = 3,
  Aggregator = 4,
}

export const MAX_DOCUMENT_SIZE = 15 * 1024 * 1024;

export const bytesToMB = (bytes: number): number => bytes / (1024 * 1024);
